import React, { useCallback, useEffect, useState } from "react";
import MessageAnalytics from "./child/MessageAnalytics";
import HourlyMessageAnalytics from "./child/HourlyMessageAnalytics";
import CampaignAnaLytics from "./child/CampaignAnaLytics";
import RecentActivityAnalytics from "./child/RecentActivityAnalytics";
import AnalyticCard from "./child/AnalyticCard";
import DeliveryStrip from "./child/DeliveryStrip";
import InstanceHealth from "./child/InstanceHealth";
import { apiCall } from "../utils/apiService";
import "./DashboardLayer.css";

const POLL_MS = 50000;

const DashboardLayer = ({ onMeta }) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);

    const fetchDashboard = useCallback(async (silent = false) => {
        try {
            if (!silent) setLoading(true);
            const res = await apiCall({
                url: `user/get-dashboard`,
                method: "GET",
            });
            setData(res || {});
            if (typeof onMeta === "function") {
                onMeta({
                    userName: res?.userName,
                    planName: res?.planName,
                    generatedAt: res?.generatedAt,
                });
            }
        } catch (error) {
            console.error("Error fetching dashboard:", error);
        } finally {
            if (!silent) setLoading(false);
        }
    }, [onMeta]);

    useEffect(() => {
        document.title = "User Dashboard";
        fetchDashboard();

        const interval = setInterval(() => fetchDashboard(true), POLL_MS);
        const onFocus = () => fetchDashboard(true);
        window.addEventListener("focus", onFocus);

        return () => {
            clearInterval(interval);
            window.removeEventListener("focus", onFocus);
        };
    }, [fetchDashboard]);

    const summary = data.summary || {};
    const charts = data.charts || {};

    return (
        <>
            {loading && !data.success && (
                <div className="text-secondary-light text-sm mb-3">Loading dashboard…</div>
            )}

            <AnalyticCard data={data} />

            <DeliveryStrip
                deliveryStats={data.deliveryStats}
                messages={summary.messages}
            />

            <InstanceHealth instances={data.instanceHealth} />

            <section className="row gy-4 mt-1">
                <MessageAnalytics
                    charts={charts}
                    summary={summary}
                    legacy={data.messageAnalytics}
                />
                <CampaignAnaLytics
                    charts={charts}
                    legacy={data.campaignAnalytics}
                />
                <RecentActivityAnalytics items={data.recentActivity} />
                <HourlyMessageAnalytics
                    charts={charts}
                    legacy={data.hourlyAnalytics}
                />
            </section>
        </>
    );
};

export default DashboardLayer;
